import { useEffect } from "react";

import useInfiniteScroll from "@repo/shopify/hooks/useInfiniteScroll";
import type { IOrdersEdgesNode } from "@repo/shopify/types/api/customer";
import type { ICaaOrder } from "@repo/shopify/types/api/customer-account";

import useOrdersQuery from "@queries/useOrders";
import useOrdersQueryCaa from "@queries/useOrdersCaa";

import { useLayoutStore } from "@store/layout";

/**
 * jp(Customer Account API)와 classic(KR/INTL Storefront API) 주문 목록을 같은 형태로 합쳐서 돌려줌
 * 두 쿼리 모두 조건부로 비활성화되므로 실제로 나가는 요청은 항상 한 쪽뿐임
 */
export default function useOrderHistory(isJp: boolean) {
  const { showFooter } = useLayoutStore();

  // classic은 accessToken이 있을 때만 조회됨 — jp는 caaToken을 쓰므로 자동으로 비활성
  const classic = useOrdersQuery();

  // CAA는 jp일 때만 조회됨
  const caa = useOrdersQueryCaa();

  const active = isJp ? caa : classic;

  const { hasNextPage } = active;

  useEffect(() => {
    showFooter(!hasNextPage);
  }, [hasNextPage]);

  const loaderEl = useInfiniteScroll({
    rootMargin: "1000px 0px 0px 0px",
    onIntersect: () => {
      void active.fetchMore();
    },
  });

  return {
    initialLoading: !active.data?.customer && active.loading,
    hasNextPage,
    loaderEl,
    orders: active.orders as { node: IOrdersEdgesNode | ICaaOrder }[],
  };
}
